import { QuestionPayloadWithContext, QuestionResponse } from "../../../../src/types/chat";
import { apiFetch } from "../api";
import { Recommendation } from "../commitments/types";

export const getResponseFromQuestion = async (question: string): Promise<QuestionResponse> => {
    const params = new URLSearchParams({
        question: question,
    });

    const data = await apiFetch(
        `/chat/run_qa?${params.toString()}`
    );

    return data as QuestionResponse;
}

export const getResponseFromQuestionWithContext = async (payload: QuestionPayloadWithContext): Promise<QuestionResponse> => {
    const data = await apiFetch(`/chat/run_contextualized_qa`, {
        method: "POST",
        body: JSON.stringify({
          question: payload.question,
          context: payload.context,
        }),
      });
    
    return data as QuestionResponse;
}

export const runMessageSuggestion = async (recommendations: Recommendation[]): Promise<any> => {
    const data = await apiFetch(`/chat/run_message_suggestion`, {
        method: "POST",
        body: JSON.stringify({
            context: {
                recommendations: recommendations,
            },
        }),
    });
    
    return data;
}

export interface MessageFeedbackPayload {
    answer: string;
    question: string;
    cypher_query: string;
    liked: string; // "true" ou "false"
}

export const setMessageFeedback = async (payload: MessageFeedbackPayload): Promise<any> => {
    const data = await apiFetch(`/chat/set_message_feedback`, {
        method: "POST",
        body: JSON.stringify(payload),
    });
    
    return data;
}

export interface HistoryMessage {
    question: string;
    answer: string;
    context: string | object;
}

export interface HistoryResponse {
    history: HistoryMessage[];
}

export const getUserHistoryMessages = async (): Promise<HistoryResponse> => {
    const data = await apiFetch(`/chat/get_user_history_msgs`);
    return data as HistoryResponse;
}